<template>
  <g>
    <path fill="#00b8c2"
          d="m16.19.42c12.08-2.67,24.53,7.83,23.78,20.38-.13,2.59-.71,5.18-1.81,7.53-.94,1.94-1.8,4.3-.81,6.38.55,1.33,1.81,2.1,2.62,3.23v.36c-2.14,1.27-5.83.3-8.03-.57-1.34-.88-2.22-.24-3.49.36C16.09,44.3.15,34.57.01,20.56-.36,11,6.87,2.05,16.19.42Zm-.21,2.81C3.38,6.29-1.69,21.98,7.32,31.62c4.89,5.47,13.35,7.21,19.94,4,3.8-1.91,4.03-.9,7.57.22-.66-1.96-.85-3.82-.2-5.81.5-2.16,1.82-4.03,2.26-6.22C39.59,11.3,28.18.39,15.98,3.23Z"/>
    <path fill="#744ccf" :style="{ fill : $attrs.fgColor }"
          d="m15.96,3.23c12.21-2.84,23.61,8.07,20.9,20.57-.43,2.19-1.76,4.06-2.26,6.22-.65,2-.45,3.85.2,5.81-3.56-1.14-3.77-2.12-7.57-.22-6.58,3.21-15.04,1.47-19.94-4C-1.71,21.98,3.37,6.29,15.96,3.23Zm5.6,8.2c-1.52.21-2.08,2.22-1.26,3.4.36.52.98.83,1.61.82,1.56,0,3.12,0,4.69,0,2.46.13,2.81-3.83.42-4.22-1.82-.06-3.65-.05-5.46,0Zm-8.82,6.54c-1.12.24-1.68,1.46-1.46,2.53.17,1.37,1.58,1.8,2.76,1.64,4.21,0,8.43,0,12.64,0,.9.03,1.75-.68,1.89-1.58.31-1.29-.58-2.72-1.97-2.65-4.62.05-9.25-.11-13.86.06Zm0,6.47c-2.05.43-1.98,3.84.1,4.16,1.72.09,3.46,0,5.18.03,1.68.03,2.48-2.16,1.55-3.43-.36-.53-1-.82-1.63-.81-1.73.03-3.48-.09-5.2.05Z"/>
  </g>
</template>

<script>
export default {
  name: "svgGap"
}
</script>

<style scoped>

</style>